"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createSvg = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _context = require("../context");

var _propTypes = require("../prop-types");

var _screenReaderOnly = require("../screen-reader-only");

var _utils = require("../utils");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

var Svg = (0, _context.styledWithTheme)('svg')(function (_ref) {
  var theme = _ref.theme,
      props = (0, _objectWithoutProperties2.default)(_ref, ["theme"]);
  var selectors = theme.selectors;
  return (0, _objectSpread2.default)({}, (0, _utils.cssValueProp)(selectors.colorOrNull, props.color, 'color'), (0, _utils.cssValueProp)(selectors.colorOrNull, props.backgroundColor, 'backgroundColor'), (0, _utils.getPropsStyles)(['alignSelf', 'display'], props), (0, _utils.getSpacingStyles)(['margin'], props, selectors.space), {
    flexShrink: 0
  });
});

var createBackgroundImageMixin = function createBackgroundImageMixin(_ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      paths = _ref2.paths;

  var mixin = function mixin(_ref3) {
    var theme = _ref3.theme,
        color = _ref3.color;
    return "url(\"data:image/svg+xml,".concat(encodeURIComponent("<svg xmlns='http://www.w3.org/2000/svg' width='".concat(width, "' height='").concat(height, "' viewBox='0 0 ").concat(width, " ").concat(height, "' style='width: ").concat(width, "px; height: ").concat(height, "px;'>").concat(paths.map(function (path) {
      return "<path fill='".concat(theme.selectors.colorOrNull(color), "' fill-rule='evenodd' d='").concat(path, "'></path>");
    }).join(''), "</svg>")), "\")");
  };

  return mixin;
};

var getSvgFromAttributes = function getSvgFromAttributes(attributes, size) {
  switch (attributes.kind) {
    case 'SVGIcon':
      return attributes.getAttributes();

    case 'SVGIconWithSizes':
      return attributes.getAttributes(size);

    default:
      throw new Error('Unsupported data object passed as icon data');
  }
};

var createSvg = function createSvg(displayName, attributes) {
  var Component = function Component(_ref4) {
    var _ref4$size = _ref4.size,
        size = _ref4$size === void 0 ? _interfaces.IconSize.Small : _ref4$size,
        _ref4$display = _ref4.display,
        display = _ref4$display === void 0 ? 'block' : _ref4$display,
        color = _ref4.color,
        margin = _ref4.margin,
        backgroundColor = _ref4.backgroundColor,
        title = _ref4.title,
        ariaHidden = _ref4['aria-hidden'],
        dataTestId = _ref4.dataTestId,
        RtlIcon = _ref4.rtl;

    var _useContext = (0, _react.useContext)(_context.StencilContext),
        i18n = _useContext.i18n,
        locale = _useContext.locale;

    var isRTL = !!i18n.isInitialized && i18n.dir(locale) === 'rtl';
    var hasTitle = !!title && !!title.trim().length;
    var isAccessible = hasTitle || ariaHidden;

    if ((0, _utils.envIsDevelopment)() && !isAccessible) {
      console.warn("For accessibility, icons should either have a 'title' or use 'aria-hidden={true}'. Check the icon with data-test-flagged='".concat(_utils.MISSING_ALT_TEXT_TEST_FLAG, "'."));
    }

    var shouldAnnounceTitle = hasTitle && (!ariaHidden || ariaHidden === 'false');
    var dataTestProps = (0, _utils.buildDataTestProps)({
      dataTestComponent: "Stencil".concat(displayName),
      dataTestId: dataTestId
    });
    var dataProps = isAccessible ? dataTestProps : (0, _objectSpread2.default)({}, dataTestProps, {
      'data-test-flagged': _utils.MISSING_ALT_TEXT_TEST_FLAG
    });

    var _getSvgFromAttributes = getSvgFromAttributes(attributes, size),
        paths = _getSvgFromAttributes.paths,
        params = _getSvgFromAttributes.params,
        width = _getSvgFromAttributes.width,
        height = _getSvgFromAttributes.height;

    return (0, _core.jsx)(_react.default.Fragment, null, RtlIcon && isRTL ? (0, _core.jsx)(RtlIcon, {
      size: size,
      display: display,
      color: color,
      margin: margin,
      backgroundColor: backgroundColor,
      title: title,
      'aria-hidden': ariaHidden,
      dataTestId: dataTestId
    }) : (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(Svg, (0, _extends2.default)({
      color: color,
      display: display,
      xmlns: "http://www.w3.org/2000/svg",
      className: "stencilSvgIcon",
      width: width,
      height: height,
      margin: margin,
      "aria-hidden": true,
      focusable: "false",
      backgroundColor: backgroundColor,
      style: {
        width: width,
        height: height
      },
      viewBox: "0 0 ".concat(width, " ").concat(height)
    }, dataProps, params), paths.map(function (d, i) {
      return (0, _core.jsx)("path", {
        key: "path".concat(i),
        fillRule: "evenodd",
        fill: "currentColor",
        d: d
      });
    })), shouldAnnounceTitle ? (0, _core.jsx)(_screenReaderOnly.ScreenReaderOnly, null, title) : undefined));
  };

  Component.displayName = displayName;
  Component.defaultProps = {
    display: 'block'
  };

  Component.getBackgroundImage = function (_ref5) {
    var _ref5$size = _ref5.size,
        size = _ref5$size === void 0 ? _interfaces.IconSize.Small : _ref5$size,
        theme = _ref5.theme,
        color = _ref5.color;

    var _getSvgFromAttributes2 = getSvgFromAttributes(attributes, size),
        paths = _getSvgFromAttributes2.paths,
        width = _getSvgFromAttributes2.width,
        height = _getSvgFromAttributes2.height;

    return createBackgroundImageMixin({
      width: width,
      height: height,
      paths: paths
    })({
      theme: theme,
      color: color
    });
  };

  var ComponentWithDocs = (0, _stencilReactDesc.describe)(Component).description("".concat(displayName, " icon."));
  ComponentWithDocs.propTypes = (0, _objectSpread2.default)({}, _propTypes.alignSelfPropTypes, _propTypes.backgroundColorPropTypes, _propTypes.colorPropTypes, _propTypes.displayPropTypes, _propTypes.marginPropTypes, {
    title: _stencilReactDesc.PropTypes.string.description('Used as alt text for the icon for screen readers. Leave blank if the icon is purely presentational.'),
    size: _stencilReactDesc.PropTypes.oneOf(Object.values(_interfaces.IconSize)).description('Determines the size of the icon.'),
    dataTestId: _stencilReactDesc.PropTypes.string.description("Sets the 'data-test-id' attribute in the DOM, for testing purposes.")
  });
  return Component;
};

exports.createSvg = createSvg;